import React from "react";
import Whats from "./Whats";
import { Fade } from "react-awesome-reveal";
import "../styles/Header.scss";
import logo from "../images/logoHF.png";

const Header = () => {
  return (
    <header className="ovit-header">
      <nav className="navbar navbar-expand-lg navBarCustom" data-bs-theme="dark">
        <div className="container-fluid navInner">
          {/* Brand */}
          <a className="navbar-brand brandWrap" href="#inicio" aria-label="OVIT Soluciones Web">
            <img className="imgLogo" src={logo} alt="Logo Ovit Soluciones Web" />
            <div className="brandText">
              <span className="brandName">OVIT</span>
              <span className="brandSub">Contenido + Campañas</span>
            </div>
          </a>

          {/* Mobile toggler */}
          <button
            className="navbar-toggler navToggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          {/* Links */}
          <div className="collapse navbar-collapse navCollapse" id="navbarSupportedContent">
            <ul className="navbar-nav me-auto mb-2 mb-lg-0 navLinks">
              <li className="nav-item">
                <a className="nav-link" href="#inicio">Nosotros</a>
              </li>

              <li className="nav-item">
                <a className="nav-link" href="#whyUs">¿Por qué no vendes?</a>
              </li>

              <li className="nav-item">
                <a className="nav-link" href="#ovit-services">Qué incluye</a>
              </li>

              {/* 👇 NUEVO: planes (para vender) */}
              <li className="nav-item">
                <a className="nav-link nav-link--hot" href="#planes">Planes</a>
              </li>

              <li className="nav-item">
                <a className="nav-link" href="#proceso">Proceso</a>
              </li>

              <li className="nav-item">
                <a className="nav-link" href="#faq">FAQ</a>
              </li>

              <li className="nav-item">
                <a className="nav-link" href="#foot">Contacto</a>
              </li>
            </ul>

            {/* Actions */}
            <div className="navActions">
              <a className="btn btnSecondary" href="#planes">
                Ver planes
              </a>

              <Fade cascade direction="left">
                <Whats
                  classStyle="btn btnContactanos"
                  message="Hola, quiero información sobre creación de contenido y campañas."
                  text="WhatsApp"
                  phoneNumber="5215588093678"
                />
              </Fade>
            </div>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Header;